import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗のカレンダー情報を取得する
 *
 * @param {Number} shopid 店舗ID
 * @returns {Response} レスポンスデータ
 */
export function getShopCalendar (shopid) {
  return request.get(`/shops/${shopid}/calendar`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
